class CartMini extends HTMLElement {
    constructor() {
      super();
  
      this.cartMini = document.querySelector('cart-mini');
      this.header = document.querySelector('sticky-header');
      this.onBodyClick = this.handleBodyClick.bind(this);
      
      document.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
      );
    }
  
    open() {
  
      this.classList.add('animate', 'active', 'open');
      
      this.cartMini.addEventListener('transitionend', () => {
        this.cartMini.focus();
        trapFocus(this.cartMini);
      }, { once: true });
  
      document.body.addEventListener('click', this.onBodyClick);
    };
  
    close() {
  
      this.classList.remove('active', 'open');
  
      document.body.removeEventListener('click', this.onBodyClick);
      document.querySelector('cart-mini-trigger').resetState();
  
      removeTrapFocus(this.activeElement);
    };
  
    getSectionInnerHTML() {
  
      fetch(`${routes.cart_url}?view=mini`)
        .then(response => response.text())
        .then(text => {
          
          const cartMini = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector('cart-mini-items').innerHTML
  
          document.querySelector('cart-mini-items').innerHTML = cartMini;
        })
        .catch(e => {
          console.error(e);
        })
        .finally(e => {
          this.disableLoading();
        });
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-product',
          selector: `#cart-notification-product-${this.productId}`,
        },
        {
          id: 'cart-notification-button'
        }
      ];
    }
  
    enableLoading() {
      this.cartMini.querySelector('.loading-overlay').classList.remove('hidden');
    }
  
    disableLoading() {
      this.cartMini.querySelector('.loading-overlay').classList.add('hidden');
    }
  
    handleBodyClick(evt) {
      const target = evt.target;
      if (target !== this.cartMini && !target.closest('cart-mini') && !target.closest('cart-mini-trigger') ) {
        this.close();
      }
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  
  customElements.define('cart-mini', CartMini);
  
  class CartMiniRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.closest('cart-mini-items').updateQuantity(this.dataset.index, 0);
        updateMiniCart();
        updateCartIconQuantity();
      });
    }
  }
  
  customElements.define('cart-mini-remove-button', CartMiniRemoveButton);
  
  class CartMiniItems extends HTMLElement {
    constructor() {
      super();
  
      this.cartMini = document.querySelector('cart-mini');
  
      this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
  
      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
  
      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);
  
      this.addEventListener('change', this.debouncedOnChange.bind(this));
    }
  
    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
  
    updateQuantity(line, quantity, name) {
  
      this.cartMini.enableLoading();
  
      const body = JSON.stringify({
        line,
        quantity,
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
  
          this.cartMini.getSectionInnerHTML();
          updateMiniCart();
          updateCartIconQuantity();
  
        }).catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.getElementById('cart-errors').textContent = window.cartStrings.error;
        });
    }
  }
  
  customElements.define('cart-mini-items', CartMiniItems);